import { useRef, useState } from 'react';
import { Modals } from '../types';
export const useOpenModalWithPromise = _ref => {
  let {
    modal,
    setActiveModal,
    onInstallationCompleted
  } = _ref;
  const [modalProps, setModalProps] = useState({});
  const promiseRef = useRef({
    resolve: _props => {},
    reject: _props => {}
  });
  const getPromise = () => new Promise((resolve, reject) => {
    promiseRef.current = {
      resolve,
      reject
    };
  });
  const fulfillPromise = props => {
    const {
      answer
    } = props;
    if (answer === 'PROCEED') {
      promiseRef.current.resolve(props);
    } else {
      onInstallationCompleted({
        status: answer
      });
    }
  };
  return {
    open: data => {
      setModalProps(data || {});
      setActiveModal(modal);
      return getPromise();
    },
    close: value => {
      setActiveModal(value.showModalAfterClose || Modals.loading);
      fulfillPromise(value);
    },
    modalProps
  };
};
export const initialOpenModalWithPromise = {
  open: () => Promise.resolve({
    answer: true
  }),
  close: () => {},
  modalProps: {}
};
//# sourceMappingURL=useOpenModalWithPromise.js.map